<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-4">
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("sectorProfile.nameKH") }}</label>
          <input
            v-model="model.sector_name_kh"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('sector_name_kh') }"
            :placeholder="$t('sectorProfile.nameKH')"
          />
          <div class="invalid-feedback" v-if="errors.has('sector_name_kh')">
            {{ errors.first("sector_name_kh") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("sectorProfile.nameEN") }}</label>
          <input
            v-model="model.sector_name_en"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('sector_name_en') }"
            :placeholder="$t('sectorProfile.nameEN')"
          />
          <div class="invalid-feedback" v-if="errors.has('sector_name_en')">
            {{ errors.first("sector_name_en") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            outline
            :waiting="waiting"
            :disabled="waiting"
            @click.prevent="onSaveAddNew"
          >
            {{ $t("saveAddNew") }}</ts-button
          >
          <ts-button
            v-if="!isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onSave"
            >{{ $t("save") }}</ts-button
          >
          <ts-button
            v-if="isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from "lodash";
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";
export default {
  name: "sectorForm",
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      showBrowseFileBotton: false,
      model: {
        sector_profile_id: null,
        sector_name_kh: null,
        sector_name_en: null,
      },
    };
  },
  computed: {
    ...mapState("academic/sectorProfile", ["edit_data"]),
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
  },
  created() {
    this.setEditData();
  },
  methods: {
    async onSave() {
      this.waiting = true;
      this.$store
        .dispatch("academic/sectorProfile/store", this.model)
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onSaveAddNew() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch("academic/sectorProfile/store", Object.assign({}, this.model))
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearEdit();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("academic/sectorProfile/update", {
          id: this.model.sector_profile_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.sector_profile_id = this.edit_data.sector_profile_id;
        this.model.sector_name_kh = this.edit_data.sector_name_kh;
        this.model.sector_name_en = this.edit_data.sector_name_en;
      }
    },
    clearEdit() {
      this.model.sector_profile_id = null;
      this.model.sector_name_kh = null;
      this.model.sector_name_en = null;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>